<template>
  <div id="page" class="flex">
      <div class="row topCardGrid">
          <sp-card stripe=""/>
          <sp-card stripe=""/>
          <sp-card stripe=""/>
          <sp-card stripe=""/>
      </div>
      <div class="row">
        <div class="flex md12 sm12">
          <sp-360-panel :title="tabela.titulo" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
              <div class="flex-box">
                <sp360-chart :data="filaSaudeChart" type="vertical-bar" :options="filaSaudeChartOptions"/>
              </div>
              <div class="flex-box">
                <div class="flex lg3 sm12 md3">
                  <multiselect id="selectSubprefeituras" name="Subprefeituras" placeholder="Selecione uma Subprefeitura"
                  track-by="NOME" label="NOME" :value="subSel" :options="subs" :close-on-select="true" :show-labels="false"
                  @input="updateMultiSelect" />
                </div>
              </div>
              <div class="flex-box">
                <sp-distritos v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" :habilitarAnimacaoClique="true"/>
                <sp360-data-table id="tabelaFilaSaude" ref="filaSaude"
                    :apiMode="false"
                    :data="tabela.tableData"
                    :fields="tabela.tableFields"
                    :perPage="tabela.itemsPerPage"
                    noDataLabel="Selecione uma região."
                />
              </div>
          </sp-360-panel>
        </div>
      </div>
      <div class="row">
        <div class="flex md12 sm12">
          <sp-360-panel :title="heatMaptitulo" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
                <div ref="xd3">
                  <div id="chartDiv"/>
                </div>
          </sp-360-panel>
        </div>
      </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import AutoUpdate from '@/services/AutoUpdate'
import SpDistritos from '@/components/maps/360-maps/SPDistritos'
import SPDistritosNomes from '@/utils/SPDistritosNomes'
import Multiselect from 'vue-multiselect'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import RankingFarmaciaMedicamento from '@/components/statistics/charts/RankingFarmacia'

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

import * as d3 from 'd3'

export default {
  name: 'medicamentos-regionalizados',
  mixins: [],
  components: { SpDistritos, Multiselect, SpCard, Sp360Chart, Sp360Panel, Sp360DataTable, RankingFarmaciaMedicamento },

  data () {
    return {
      dados: [],
      set: [],
      tooltip: { placement: 'bottom', content: 'empty' },
      tabela: {
        titulo: this.$t('graficosSaude.situacaoFarmacias.titulo'), // this.$t('graficosSaude.filaProcedimentosPorRegiao'),
        tableData: [],
        tableFields: [
          {
            name: 'unidade',
            sortField: 'unidade',
            //title: 'Farmacia',
            title: this.$t('graficosSaude.situacaoFarmacias.farmacia'),
            width: '12%',
          },
          {
            name: 'medicamento',
            sortField: 'medicamento',
           // title: 'Mediacamento',
           title: this.$t('graficosSaude.situacaoFarmacias.medicamento'),
            width: '25%',
          },
          {
            name: 'cobertura_rede_dias',
            sortField: 'cobertura_rede_dias',
            //title: 'Cobertura (dias)',
            title: this.$t('graficosSaude.situacaoFarmacias.cobertura'),
            callback: MethGlob.thousandSeparator,
            width: '10%',
          },
          {
            name: 'perc_estoque',
            sortField: 'perc_estoque',
            //title: 'Estoque (%)',
            title: this.$t('graficosSaude.situacaoFarmacias.estoque'),
            callback: MethGlob.thousandSeparator,
            width: '10%',
          },
          {
            name: 'cmm',
            sortField: 'cmm',
            //title: 'Consumo médio mensal (unidade)',
            title: this.$t('graficosSaude.situacaoFarmacias.cmm'),
            callback: MethGlob.thousandSeparator,
            width: '10%',
          },
        ],
        sortFunctions: {
          'subprefeitura': MethGlob.ordenaTabela,
          'total': MethGlob.ordenaTabelaParseInt,
          'procedimentos_clinicos': MethGlob.ordenaTabelaParseInt,
          'procedimentos_com_finalidade_diagnostica': MethGlob.ordenaTabelaParseInt,
          'orteses_proteses_e_materiais_especiais': MethGlob.ordenaTabelaParseInt,
          'procedimentos_cirurgicos': MethGlob.ordenaTabelaParseInt,
        },
        topTooltipOptions: {
          content: this.$t('graficosSaude.tooltipFilaProcedimentosPorRegiao'), placement: 'bottom', classes: 'va-tooltip tooltip vuestic-tooltip customTooltip',
        },
        itemsPerPage: 12,
      },
      filaSaudeChartOptions: {},
      filaSaudeChart: {},
      medias: [],
      dadosTree: [],
      farmacias: [],
      subSelecionada: 0,
      subSel: null,
      fonte: '',
      dataRef: '',
      ref: '',
      distritoSelecionado: 'Municipio',
      subs: _.orderBy(SPDistritosNomes, 'NOME', ['ASC']),
    }
  },

  computed: {
    heatMaptitulo: function () {
      return 'Situração das Farmácias em : ' + this.distritoSelecionado
    },
  },

  created () {
    Promise.all([
      this.$store.dispatch('saude/buscarMedicamentosPorFarmacia', { }),
      this.$store.dispatch('saude/buscarEstoqueDeRemediosPorUnidade', {}),
    ]).then(respostas => {
      this.listaMedicamentos = this.filtarMedicamentos(_.orderBy(respostas[0].data.data, ['id_medicamento'], ['desc']))
      this.medicamentos = _.orderBy(respostas[0].data.data, ['cmm'], ['desc'])

      this.farmacias = respostas[1].data.data
      this.medicamentos = this.nomearUnidades(this.medicamentos, this.farmacias)
      this.medias = this.calcularMedias(this.medicamentos)
      this.popularTabela(this.medicamentos)
      this.pintarRegiao(this.medias)
      this.criarLegenda(_.minBy(this.medias, 'media').media, _.maxBy(this.medias, 'media').media)
      this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
      this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
    })
  },

  beforeDestroy () {
  },

  methods: {
    filtarMedicamentos (dados) {
      let a = []
      let data = _.groupBy(dados, 'id_medicamento')

      for (const i in data) {
        let z = data[i].reduce((accumulator, currentValue) => {
          accumulator.estoqueTotal += (currentValue.estoque)
          accumulator.coberturaMedia += (currentValue.cobertura_rede_dias / data[i].length)
          accumulator.cunsumoMedio += (currentValue.cmm)
          accumulator.medicamento = currentValue.medicamento
          accumulator.id_medicamento = currentValue.id_medicamento

          return (accumulator)
        }, { estoqueTotal: 0, coberturaMedia: 0, cunsumoMedio: 0, medicamento: '', id_medicamento: 0 })

        a.push(z)
      }
      return a
    },

    defineDados (dados) {

    },

    simpleHeatMap (dados) {
      dados = _.orderBy(dados, 'cobertura_rede_dias', ['ASC'])
      // Remove everything
      this.clearHeatChart()

      // do the shit
      let uniqMed = _.uniqBy(dados, 'id_medicamento')
      let uniqFar = _.uniqBy(dados, 'cnes')
      let max = _.maxBy(dados, 'cobertura_rede_dias')
      let domain = max.cobertura_rede_dias
      // set the dimensions and margins of the graph
      let w = this.$refs.xd3.clientWidth
      let h = this.$refs.xd3.clientHeight

      let margin = { top: 10, right: 25, bottom: 200, left: 500 }
      let width = w - margin.left - margin.right
      let height = h - margin.top - margin.bottom

      // append the svg object to the body of the page
      var svg = d3.select('#chartDiv')
        .append('svg')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('viewBox', '0 0 ' + w + ' ' + h)
        .attr('preserveAspectRatio', 'xMinYMin meet')
        .append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      // Labels of row and columns -> unique identifier of the column called 'group' and 'variable'
      var myGroups = d3.map(dados, function (d) { return d.unidade }).keys()
      var myVars = d3.map(dados, function (d) { return d.medicamento }).keys()

      // Build X scales and axis:
      var x = d3.scaleBand()
        .range([ 0, width ])
        .domain(myGroups)
        .padding(0.05)

      svg.append('g')
        .attr('id', 'eixoX')
        .style('font-size', 8)
        .attr('transform', 'translate(0,' + height + ')')
        .call(d3.axisBottom(x).tickSize(5))
        .selectAll('text')
        .style('text-anchor', 'end')
        .attr('dx', '-.8em')
        .attr('dy', '.15em')
        .attr('transform', 'rotate(-90)')

      // Build Y scales and axis:
      var y = d3.scaleBand()
        .range([ height, 0 ])
        .domain(myVars)
        .padding(0.05)

      svg.append('g')
        .attr('id', 'eixoY')
        .style('font-size', 7)
        .call(d3.axisLeft(y).tickSize(3))
        .selectAll('text')

      // Build color scale
      let colors = CorUtils.getCoresMapa()
      var myColor = d3.scaleSequential()
        .interpolator(d3.interpolateHcl(colors.claro, colors.medio, colors.escuro))
        .domain([0, domain])

      svg.selectAll('.domain').remove()

      // create a tooltip
      var tooltip = d3.select('#chartDiv')
        .append('div')
        .style('opacity', 0)
        .attr('class', 'tooltip')
        .style('background-color', 'white')
        .style('border', 'solid')
        .style('border-width', '2px')
        .style('border-radius', '5px')
        .style('padding', '5px')

      // Three function that change the tooltip when user hover / move / leave a cell
      var mouseover = function (d) {
        tooltip
          .style('opacity', 1)
        d3.select(this)
          .style('stroke', 'Lighten')
          .style('opacity', 1)
      }
      var mousemove = function (d) {
        tooltip
          .html('Medicamento: ' + d.medicamento + '</br>' + 'Coberduta da rede em dias: ' + d.cobertura_rede_dias + '</br>' + 'Consumo Medio Mensal: ' + d.cmm)
          .style('left', (d3.mouse(this)[0] + 70) + 'px')
          .style('top', (d3.mouse(this)[1]) + 'px')
      }
      var mouseleave = function (d) {
        tooltip
          .style('opacity', 0)
        d3.select(this)
          .style('stroke', 'none')
          .style('opacity', 0.8)
      }

      // add the squares
      svg.selectAll()
        .data(dados, function (d) { return d.unidade + ':' + d.medicamento })
        .enter()
        .append('rect')
        .attr('id', function (d) { return 'rect_' + d.cnes + '_' + d.id_medicamento })
        .attr('v-tooltip', function (d) { return { content: 'Medicamento: ' + d.medicamento + '</br>' + 'Coberduta da rede em dias: ' + d.cobertura_rede_dias + '</br>' + 'Consumo Medio Mensal: ' + d.cmm, placement: 'right' } })
        .attr('x', function (d) { return x(d.unidade) })
        .attr('y', function (d) { return y(d.medicamento) })
        .attr('rx', 4)
        .attr('ry', 4)
        .attr('width', x.bandwidth())
        .attr('height', y.bandwidth())
        .style('fill', function (d) {
          return myColor(d.cobertura_rede_dias)
        })
        .style('stroke-width', 4)
        .style('stroke', 'none')
        .style('opacity', 0.8)
        .on('mouseover', mouseover)
        .on('mousemove', mousemove)
        .on('mouseleave', mouseleave)
        .on('mouseover', function (d) {
          tooltip.transition()
            .duration(200)
            .style('opacity', 0.9)
          tooltip.html('Medicamento: ' + d.medicamento + '</br>' + 'Coberduta da rede em dias: ' + d.cobertura_rede_dias + '</br>' + 'Consumo Medio Mensal: ' + d.cmm)
            .style('left', (d3.event.pageX - 100) + 'px')
            .style('top', (d3.event.pageY) + 'px')
        })
        .on('mouseout', function (d) {
          tooltip.transition()
            .duration(500)
            .style('opacity', 0)
        })
    },

    calcularMedias (dados) {
      let a = []
      this.data = _.groupBy(dados, 'id_distrito')
      for (const i in this.data) {
        let media = this.data[i].reduce((accumulator, currentValue) => {
          let y = (currentValue.cobertura_rede_dias / this.data[i].length)
          return (accumulator += y || 0)
        }, 0)
        let z = { media: media, distrito: i }
        a.push(z)
      }
      return a
    },

    updateMultiSelect (value) {
      if (!value) { // false
        value = this.subSel // use o ultimo selecionado
      }
      this.filtrarPorRegiao(value.id)
    },

    filtrarPorRegiao (id) {
      let distrito = SPDistritosNomes.find(e => e.id === id)
      this.distritoSelecionado = distrito.nome
      this.$refs.mapa.limparClick(this.subSelecionada)
      if (this.subSelecionada !== id) {
        this.subSelecionada = id
        this.$refs.mapa.filtrar(this.subSelecionada, false)
        this.filtrarTabela(this.subSelecionada)
        this.$refs.mapa.emulateClick(this.subSelecionada)
      } else {
        this.$refs.mapa.filtrar(this.subSelecionada, false)
        this.subSelecionada = 0
        this.filtrarTabela(this.subSelecionada)
        this.distritoSelecionado = 'Municipio'
        this.clearHeatChart()
      }
    },

    popularTabela (dados) {
      this.tabela.tableData = []
    },

    filtrarTabela (id) {
      if (id) {
        for (const key in this.data) {
          if (this.data.hasOwnProperty(key)) {
            if (key === id) {
              const element = this.data[key]
              element.forEach((f) => {
                let a = this.farmacias.find((farma) => {
                  if (farma.cnes === f.cnes) {
                    return farma
                  }
                })
                f.unidade = a.unidade
              })
              this.$nextTick(() => {
                let resultSet = _.orderBy(element, 'cobertura_rede_dias', 'asc')
                this.$set(this.tabela, 'tableData', resultSet)
                this.simpleHeatMap(resultSet)
              })
            }
          }
        }
      } else {
        this.$nextTick(() => {
          this.$set(this.tabela, 'tableData', [])
          // this.simpleHeatMap([])
        })
      }
    },

    criarLegenda (min, max) {
      this.$refs.mapa.setLegenda(min, max, this.$t('graficosSaude.textoEixoLegenda.estoqueEmDias'))
      let c = CorUtils.getCoresMapa()
      this.$refs.mapa.definirLegenda(
        [c.claro, c.escuro],
        [this.$t('graficosSaude.legenda.demanda'),
          this.$t('graficosSaude.legenda.baixa'),
          this.$t('graficosSaude.legenda.media'),
          this.$t('graficosSaude.legenda.alta')]
      )
    },

    // Pinta as areas do mapa de acorco com um valor arbitrario
    // TODO : Delimitar uma formula para o farol.
    pintarRegiao (dados) {
      let cores = CorUtils.getCoresMapa()
      dados = _.orderBy(dados, ['media'], ['asc'])
      let colorScale = d3.scaleLinear()
        .domain([_.minBy(dados, 'media').media, _.maxBy(dados, 'media').media])
        .range([cores.claro, cores.escuro])
      dados.forEach(e => {
        this.$refs.mapa.pintarRegiao(e.distrito, colorScale(e.media))
      })
    },

    getchartOptions (xAxixLabel, yAxixLabel, chartData) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 50,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              if (tooltipItems[0].datasetIndex === _.findIndex(chartData.datasets, (o) => o.yAxisID === 'LineAxis')) {
                return 'Acumulado'
              }
              let title = ''
              let labels = data.labels
              let labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                let item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }

              return title
            },
            label: function (tooltipItem, details) {
              if (details.datasets[tooltipItem.datasetIndex].yAxisID == 'LineAxis') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return currentValue.toFixed(2) + '%'
              } else {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + MethGlob.thousandSeparator(currentValue)
              }
            },
          },
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,

            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [
            {
              id: 'BarAxis',
              position: 'left',
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: yAxixLabel,
              },
              ticks: {
                callback: function (value, index, values) {
                  return MethGlob.thousandSeparator(value)
                },
              },
            },
            {
              id: 'LineAxis',
              position: 'right',
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Percentual de Cada sub em relação ao total',
              },
              ticks: {
                callback: function (value, index, values) {
                  return value + '%'
                },
              },
            }],
        },
      }
    },

    fillDataSet (barchartData, dados, atr_data, atr_leg, dataset_label, backgroundColor) {
      let palette = this.$store.getters.palette
      let dataset = {
        backgroundColor: backgroundColor,
        borderColor: palette.transparent,
        data: [],
        yAxisID: 'BarAxis',
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MethGlob.thousandSeparator(value),
          anchor: 'end',
          rotation: -90,
          align: 'end',
          display: 'true',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }

      let datasetLine = {
        backgroundColor: CorUtils.setAlpha(CorUtils.getCorPorNomeSp360('cinza-medio'), 40),
        borderColor: CorUtils.getCorPorNomeSp360('amarelo-bistre-claro'),
        type: 'line',
        yAxisID: 'LineAxis',
        data: [],
        datalabels: {
          labels: {
            title: null,
          },
        },
      }

      let aux = 0
      let total = 0

      dados.forEach(element => {
        if (element) {
          barchartData.labels.push(element[atr_leg])
          dataset.data.push(element[atr_data])
          dataset.label = dataset_label
          total += element[atr_data]
        }
      })

      dados.forEach(element => {
        aux += ((element[atr_data] / total) * 100)
        datasetLine.data.push(aux)
      })

      barchartData.datasets.push(datasetLine) // HardCoded <- pode ser afetado pela ordem de definição dos datasets. Recomanda-se não mudar
      barchartData.datasets.push(dataset)
      return barchartData
    },

    heatMapAMCharts (dados) {
      am4core.ready(() => {
        am4core.useTheme(am4themes_animated)
        this.chart = am4core.create('charDiv', am4charts.XYChart)
        this.chart.maskBullets = false

        let xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
        let yAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())

        xAxis.dataFields.category = 'id_distrito'
        yAxis.dataFields.category = 'medicamento'

        xAxis.renderer.grid.template.disabled = true
        xAxis.renderer.minGridDistance = 40

        yAxis.renderer.grid.template.disabled = true
        yAxis.renderer.inversed = true
        yAxis.renderer.minGridDistance = 30

        let series = this.chart.series.push(new am4charts.ColumnSeries())
        series.dataFields.categoryX = 'id_distrito' // weekday
        series.dataFields.categoryY = 'medicamento' // hour
        series.dataFields.value = 'cmm' // value
        series.sequencedInterpolation = true
        series.defaultState.transitionDuration = 3000

        let bgColor = new am4core.InterfaceColorSet().getFor('background')

        let columnTemplate = series.columns.template
        columnTemplate.strokeWidth = 1
        columnTemplate.strokeOpacity = 0.2
        columnTemplate.stroke = bgColor
        columnTemplate.tooltipText = '{id_distrito}, {medicamento}: {cmm}'
        columnTemplate.width = am4core.percent(100)
        columnTemplate.height = am4core.percent(100)

        series.heatRules.push({
          target: columnTemplate,
          property: 'fill',
          min: am4core.color(bgColor),
          max: this.chart.colors.getIndex(0),
        })

        // heat legend
        this.heatLegend = this.chart.bottomAxesContainer.createChild(am4charts.HeatLegend)
        this.heatLegend.width = am4core.percent(100)
        this.heatLegend.series = series
        this.heatLegend.valueAxis.renderer.labels.template.fontSize = 9
        this.heatLegend.valueAxis.renderer.minGridDistance = 30

        // heat legend behavior
        series.columns.template.events.on('over', function (event) {
          this.handleHover(event.target)
        })

        series.columns.template.events.on('hit', function (event) {
          this.handleHover(event.target)
        })

        series.columns.template.events.on('out', function (event) {
          this.heatLegend.valueAxis.hideTooltip()
        })
        this.chart.data = dados
      })
    },

    handleHover (column) {
      if (!isNaN(column.dataItem.value)) {
        this.heatLegend.valueAxis.showTooltipAt(column.dataItem.value)
      } else {
        this.heatLegend.valueAxis.hideTooltip()
      }
    },

    nomearUnidades (dados, farmacias) {
      dados.forEach((d) => {
        let a = this.farmacias.find((farma) => {
          if (farma.cnes === d.cnes) {
            return farma
          }
        })
        d.unidade = a.unidade
      })
      return dados
    },

    clearHeatChart () {
      d3.select('#chartDiv').selectAll('*').remove()
    },
  },

}
</script>

<style lang="scss" scoped>
    .va-chart {
      max-height: 25rem
    }
    .flex-box{
      display: flex;
    }
    #mapaSP{
      width: 25%;
    }
    #chartDiv {
      width: 100%;
      height: 150rem;
    }
    #tabelaFilaSaude{
      width: 75%;
      height: auto
    }
    .svg-container {
      display: inline-block;
      position: relative;
      width: 100%;
      padding-bottom: 100%; /* aspect ratio */
      vertical-align: top;
      overflow: hidden;
    }
    .svg-content-responsive {
      display: inline-block;
      position: absolute;
      top: 10px;
      left: 0;
    }
</style>
